import { useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";
import { captureEvent } from "../../../../utils/posthog";
import { Event } from "../../../../constants/events";

export const useNavigateMap = () => {
  const navigate = useNavigate();

  return useCallback((accountName: string, map: string) => {
    captureEvent(Event.MapNavigateToOverview, {
      map,
    });
    void navigate({
      to: "/$accountName/maps/$map/ai",
      params: { map, accountName },
    });
  }, [navigate]);
};
